import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import { auth, db } from "./firebaseConfig";

export const signUp = async (email, password) => {
  try {
    console.log("Attempting to sign up with:", email, password);
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    console.log("Signup successful:", userCredential);
    return userCredential;
  } catch (error) {
    console.error("Error during signup:", error);
    throw error;
  }
};

export const logIn = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log("Login successful");
    return userCredential;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const logOut = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    throw error;
  }
};

export const setupPractice = async (practiceInfo, userId, email) => {
  try {
    await setDoc(doc(db, "practices", userId), {
      practiceName: practiceInfo.practiceName,
      officeAddress: practiceInfo.officeAddress,
      officeCity: practiceInfo.officeCity,
      officeState: practiceInfo.officeState,
      officeZipCode: practiceInfo.officeZipCode,
      officePhone: practiceInfo.officePhone,
      email: email.toLowerCase(),
      status: 'Pending'
    });
    alert('Signup successful.');
  } catch (error) {
    console.error("Error during practice setup:", error);
    throw error;
  }
};


export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return "Password reset email sent successfully";
  } catch (error) {
    console.error("Error sending password reset email:", error);
    throw error;
  }
};